var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 21.875H29.834C25.4395 21.875 21.875 25.4395 21.875 29.834C21.875 32.0117 22.8809 33.1836 23.75 33.7891C24.4141 34.248 25 34.9609 25 35.7715C25 36.7285 24.2188 37.5098 23.2617 37.5098H23.0176C22.7832 37.5098 22.5488 37.4707 22.3242 37.373C20.5859 36.6016 12.5 32.5586 12.5 23.4375C12.5 15.6738 18.7988 9.375 26.5625 9.375H34.375V3.38867C34.375 1.51367 35.8887 0 37.7637 0C38.6035 0 39.4043 0.3125 40.0293 0.869141L53.5254 13.0176C54.2676 13.6816 54.6875 14.6289 54.6875 15.625C54.6875 16.6211 54.2676 17.5684 53.5254 18.2324L39.9512 30.4492C39.375 30.9668 38.6328 31.25 37.8613 31.25H37.5C35.7715 31.25 34.375 29.8535 34.375 28.125V21.875ZM7.8125 9.375C6.95312 9.375 6.25 10.0781 6.25 10.9375V42.1875C6.25 43.0469 6.95312 43.75 7.8125 43.75H39.0625C39.9219 43.75 40.625 43.0469 40.625 42.1875V37.5C40.625 35.7715 42.0215 34.375 43.75 34.375C45.4785 34.375 46.875 35.7715 46.875 37.5V42.1875C46.875 46.5039 43.3789 50 39.0625 50H7.8125C3.49609 50 0 46.5039 0 42.1875V10.9375C0 6.62109 3.49609 3.125 7.8125 3.125H12.5C14.2285 3.125 15.625 4.52148 15.625 6.25C15.625 7.97852 14.2285 9.375 12.5 9.375H7.8125Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.854616c387fc7bdc17da0f51f98d36d6.svg";
export { ForwardRef as ReactComponent };